export default __webpack_public_path__ + "static/media/f.73979709.png";